var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 222,
    viewBox: "0 0 57 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-62.045 24.5687C-35.1391 28.6093 -6.1208 19.8892 15.5922 36.2842C39.8334 54.5881 58.812 83.6508 56.2909 113.921C53.8697 142.993 25.2269 159.984 3.65427 179.621C-16.3302 197.812 -35.047 220.45 -62.045 221.639C-89.8311 222.864 -113.659 204.857 -133.802 185.678C-154.588 165.886 -169.859 142.127 -175.174 113.921C-181.936 78.0347 -195.779 31.4791 -167.122 8.84453C-138.23 -13.9752 -98.4536 19.1009 -62.045 24.5687Z",
    fill: "#0DD3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern05);
export default __webpack_public_path__ + "static/media/pattern-05.fa4441cb0fe79fb65dda29101eb1f98c.svg";
export { ForwardRef as ReactComponent };